import { Component, computed, input } from '@angular/core';
import { TooltipModule } from 'primeng/tooltip';

@Component({
  selector: 'app-initials-avatar',
  imports: [
    TooltipModule
  ],
  templateUrl: './initials-avatar.component.html',
  styleUrl: './initials-avatar.component.scss'
})
export class InitialsAvatarComponent {
  displayName = input<string>('');
  tooltip = input<string>('');

  initials = computed<string>(() => {
    const name = this.displayName();
    if (!name) return 'U';
    try {
      const split = name.split(' ');
      if (split.length === 1) return name.slice(0, 2);
      return split[0][0] + split[1][0];
    } catch (e) {
      return 'U';
    }
  });

}
